import { render, staticRenderFns } from "./SpadD_Total.vue?vue&type=template&id=7ac060c7"
import script from "./SpadD_Total.vue?vue&type=script&lang=js"
export * from "./SpadD_Total.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports